import type { JSX } from 'react';

import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';

export const CustomVolumeSolid = (props: SvgIconProps): JSX.Element => (
    <SvgIcon {...props} viewBox="0 0 16 16">
        <path
            d="M2.3335 7.33333H3.66683V14H2.3335V7.33333Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={0.6}
        />
        <path d="M5.66683 2H7.00016V14H5.66683V2Z" fill="currentColor" stroke="currentColor" strokeWidth={0.6} />
        <path
            d="M9.00016 9.33333H10.3335V14H9.00016V9.33333Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={0.6}
        />
        <path
            d="M12.3335 5.33333H13.6668V14H12.3335V5.33333Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth={0.6}
        />
    </SvgIcon>
);
